import { useQueryParams } from "@madkom/query-params";
import { Tbody } from "@chakra-ui/react";

import { SkeletonTableBody } from "components/Table/SkeletonTableBody";

import { useGetPaginatedUserAppointments } from "../../../../infrastructure/useGetPaginatedUserAppointments";

import { ExpiredAppointmentRow } from "./ExpiredAppointmentRow";

interface IProps {
  limit: number;
}

const ExpiredAppointmentsTableBody = ({ limit }: IProps) => {
  const { params } = useQueryParams<{ offset: number }>();
  const { data: appointments, isFetched } = useGetPaginatedUserAppointments(
    {
      limit: limit,
      offset: params.offset,
      expired: true,
    },
    {
      suspense: false,
    }
  );

  if (!appointments || !isFetched) {
    return <SkeletonTableBody rowsNum={limit} colNum={6} />;
  }

  return (
    <Tbody maxW="1000px">
      {appointments.userAppointments.map((appointment) => {
        return <ExpiredAppointmentRow appointment={appointment} />;
      })}
    </Tbody>
  );
};

export { ExpiredAppointmentsTableBody };
